export default function Loader() {
	return <div className="prc-loader" />;
}
